<app-header></app-header>

<div class="mfa-page">
  <div class="mfa-card">
    <div class="mfa-card-banner">
      <div class="brand">
        <span class="vimacc">vima<span class="vimacc-cc">cc</span></span
        ><span class="reg">®</span>
        <div class="vimacc-ol">License Portal</div>
      </div>
    </div>

    <form [formGroup]="codeForm" class="mfa-card-body">
      <h2 class="mfa-title">{{ "mfa.verifyTitle" | translate }}</h2>
      <p class="mfa-instruction">{{ "mfa.verifyInstruction" | translate }}</p>

      <mat-form-field appearance="outline" class="code-field">
        <mat-label>{{ "mfa.codeLabel" | translate }}</mat-label>
        <input
          matInput
          type="text"
          inputmode="numeric"
          autocomplete="one-time-code"
          placeholder="000000"
          formControlName="code"
        />
      </mat-form-field>

      <div *ngIf="error" class="mfa-error">{{ error | translate }}</div>

      <button
        mat-flat-button
        color="primary"
        class="mfa-btn full"
        [disabled]="!codeForm.valid || submitting"
        (click)="verify()"
      >
        {{ "mfa.verify" | translate }}
      </button>

      <a (click)="backToLogin()" class="back-link">{{ "login.backToLogin" | translate }}</a>
    </form>
  </div>
</div>

<app-footer></app-footer>
